import { SEGMENT_DETECTORS } from './patterns';

export const ID_PLACEHOLDER = ':id';

const isIdSegment = (segment: string) => SEGMENT_DETECTORS.some(detector => detector.test(segment));

/**
 * Turn a URL (absolute or path-relative) into a low-cardinality route template:
 *  - drops the query string entirely,
 *  - replaces any identifier-like path segment (uuid, cuid, numeric, long hex) with `:id`.
 *
 * Works on strings only (no `URL` parsing) so it is isomorphic and tolerant of
 * relative paths. Host segments (which contain dots) never match an id detector, so
 * `https://api.example.com/reports/<cuid>/summary?token=x` → `https://api.example.com/reports/:id/summary`.
 *
 * This is the guaranteed floor: it runs even when a router has already parameterized
 * the path, so a raw/404/un-templated URL slipping through is still stripped.
 */
export const scrubUrl = (url: string): string => {
  const [pathPart = ''] = url.split('?');

  return pathPart
    .split('/')
    .map(segment => (isIdSegment(segment) ? ID_PLACEHOLDER : segment))
    .join('/');
};
